import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { Link } from 'react-router-dom';
import decodeURIComponentSafe from '../helpers/decodeURIComponentSafe';
import { heroStreamShape } from '../helpers/propTypeShapes';

momentDurationFormatSetup(moment);

const RecordingLink = ({ stream }) => {
  const thumbnail = stream?.thumbnail ?? '/FPO_video_thumb.png';
  const broadcastName =
    decodeURIComponentSafe(stream?.broadcast?.name ?? '') ||
    decodeURIComponentSafe(stream?.title ?? '') ||
    [decodeURIComponentSafe(stream?.user?.name ?? ''), decodeURIComponentSafe(stream?.user?.location ?? '')].join(', ');

  const formattedDuration = moment.duration(stream.durationSeconds, 'seconds').format();

  const userName =
    decodeURIComponentSafe(stream?.broadcast?.user?.name ?? '') || decodeURIComponentSafe(stream?.user?.name ?? '');

  const streamName =
    decodeURIComponentSafe(stream?.broadcast?.remoteStream?.name ?? '') ||
    decodeURIComponentSafe(stream?.remoteStream?.name ?? '');

  const href =
    stream.broadcast !== null
      ? `/broadcastdetails/broadcast/${stream.broadcast.hash}/${stream.broadcast.id}/streams`
      : `/broadcastdetails/stream/${stream.remoteStream.token}/${stream.id}/streams`;

  return (
    <li className="grid-broadcast-item type-b">
      <Link to={href}>
        <div className="poster-container" style={{ backgroundImage: `url(${thumbnail})` }}>
          <div className="blur-layer">
            <img className="broadcast-poster" src={thumbnail} alt="past broadcast" />
          </div>
        </div>
        {stream.durationSeconds && <div className="stream-duration">{formattedDuration}</div>}
        <span className="grid-broadcast-name">{broadcastName}</span>
        <div>
          <span className="byline">{userName}</span>
        </div>
        <div>
          <span className="byline">
            {moment(stream.startedAt).format('MMM Do YYYY, h:mm a')}
            &nbsp;&middot;&nbsp;
            {streamName}
          </span>
        </div>
      </Link>
    </li>
  );
};

RecordingLink.propTypes = {
  stream: heroStreamShape.isRequired,
};

export default RecordingLink;
